module.exports = __webpack_public_path__ + "img/jgsfjg.0a7f3f86.png";